import { Box } from '@mui/material';
import { motion, useReducedMotion } from 'framer-motion';
import { PropsWithChildren } from 'react';

import { pageSlideHorizontalVariants } from './framer-variants';

export interface PageSlideHorizontalAnimationProps {
  direction?: 'forward' | 'back';
}

export const PageSlideHorizontalAnimation = ({
  direction = 'forward',
  children,
}: PropsWithChildren<PageSlideHorizontalAnimationProps>) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        height: ['100dvh', '100vh'],
        overflow: 'hidden',
        position: 'absolute',
        top: 0,
        isolation: 'isolate',
      }}
    >
      {!shouldReduceMotion && (
        <motion.div
          className="Page"
          custom={{ direction }}
          initial="initial"
          animate="in"
          exit="out"
          variants={pageSlideHorizontalVariants}
          style={{
            width: '100vw',
            height: '100%',
          }}
        >
          {children}
        </motion.div>
      )}

      {shouldReduceMotion && <>{children}</>}
    </Box>
  );
};
